import React, { useState } from 'react';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import { Row, Col, Select, Input, Radio, Button } from 'antd';
import { GUTTER_MD,GUTTER_XS,  MARGIN_SM, MARGIN_XS, MODAL_WIDTH_MD, SPAN_FULL, SPAN_TWO_QUARTERS } from '../../../../../../../styles/constants';
import {connect} from 'react-redux';
import _ from "lodash";
import Selector from '../../../../../../../components/selector';
import EnhancedModal from '../../../../../../../components/enhanced-modal';
import { getDistinctTempTable, onChangeIfFunction } from '../../actions';
import { DataLanguageConsumer } from '../../../../../../../contexts/DataLanguage';
import InfiniteScrollDataTable from '../../../../../../../components/infinite-scroll-data-table';
import { getFilterObjFromViewerObj } from '../../../../../../../utils/filter';
import { createExpressionToQuery } from '../../../utils';


const mapStateToProps = state => ({
    tempTable: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
    selectDistinctData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.selectDistinctData,
    nameValue:state.scenes.dataManager.fileMapping.components.wizard.components.addField.FunctionFormData.nameValue
});

const mapDispatchToProps = dispatch => ({
    onChangeForm: value => dispatch(onChangeIfFunction(value)),
    onGetDistinctTempTable:({tempTable, query, filters, pageNum,pageSize,sortByDesc, sortCol}) => dispatch(getDistinctTempTable(tempTable, query,  filters, pageNum,pageSize,sortByDesc, sortCol))
})


const IffCondition = ({
                      t,
                      tempTable,
                      onGetDistinctTempTable,
                      selectDistinctData,
                      value,
                      selectFunction,
                      selectComponent,
                      selectOperators,
                      onChangeForm,
                      block
                    }) => {

const [modalFunctionValueVisible, setModalFunctionValueVisible] = useState(false)
const condition = React.useMemo(()=> { return value},[value])
const [selectedSeries, setSelectedSeries] = React.useState([])
const blockIndex = React.useMemo(()=> { return block.blockIdx},[block])

const selectorAvailable = React.useMemo(()=> {
    const {functionName,componentName, values, operator} = value
    switch(functionName){
        case 'Str func':
            return !!componentName && !!operator;
        case 'Replace':
            return !!componentName && !!operator && !!values.replace && !!values.with;
        case 'LPad':
        case 'RPad':
            return !!componentName && !!operator && !!values.pattern;
        case 'Trim':
            return !!componentName;
        case 'LTrim':
        case 'RTrim':
            return !!componentName && !!operator && !!values.chars;
        case 'Substr':
            return !!componentName && !!operator && !!values.start && !!values.end;
        default:
            return false;
    }
},[value])


  return (<React.Fragment>
   {condition &&
   <React.Fragment>
   <Row type="flex" align='middle'>
        <Col span={4}>
            <Row>
                <span >{t('scenes.dataManager.fileMapping.wizard.addField.functions.iif.label.condition')}</span> 
            </Row>
        </Col>
        <Col span={20}>
            <Row style={{textAlign:'left', marginBottom:'5px'}}>
                <Radio.Group size="small" 
                value={condition.logicalOperator}
                disabled={condition.idx === 0}
                onChange={({target}) => onChangeForm({blockIdx: blockIndex, idx: condition.idx,  logicalOperator:target.value })}>      
                {['AND', 'OR'].map(op =>
                    <Radio.Button key={op} value={op}>{op}</Radio.Button>)
                }
                </Radio.Group>    
            </Row>  
            <Row type='flex' align='middle'>     
                <Col span={SPAN_FULL} style={{display:'flex', flexDirection:'column', alignItems:'flex-start' }}>
                    <Row type="flex" style={{ flexDirection:'column', border:'1px solid #DADADA', padding:24, rowGap:10}}> 
                        <Row type='flex'  >    
                            <Col style={{marginRight:MARGIN_XS}}>
                                <Select
                                    style={{width:120}} 
                                    value={condition.functionName}
                                    title={condition.functionName}
                                    onChange={(v)=> onChangeForm({blockIdx: blockIndex, idx: condition.idx, functionName: v })}
                                    >
                                    {!!selectFunction && selectFunction.map((field) => (
                                        <Select.Option
                                            key={field}
                                            value={field}
                                            title={`${field}`}
                                            >
                                            {field}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col style={{marginRight:MARGIN_XS}}>
                                <Select
                                    title={condition.componentName}
                                    value={condition.componentName}
                                    style={{width:140}}
                                    onChange={(value) => onChangeForm({blockIdx: blockIndex, idx: condition.idx, componentName: value })}
                                    >
                                    {!!selectComponent && selectComponent.map((field) => (
                                        <Select.Option
                                            key={field}
                                            value={field}
                                            title={`${field}`}
                                            >
                                            {field}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col style={{marginRight:MARGIN_XS}}>
                                <Select
                                value={condition.operator}
                                style={{width:100}}
                                onChange={(value) => onChangeForm({blockIdx: blockIndex, idx: condition.idx, operator: value}) }
                                >
                                {selectOperators && selectOperators.map((operator, index) => (
                                    <Select.Option
                                        title={operator}
                                        key={`operator_${index}`}
                                        value={operator}
                                        >
                                        {operator}
                                    </Select.Option>
                                ))}    
                                </Select>  
                            </Col>
                            <Col style={{marginRight:MARGIN_SM}}>
                                    <Selector
                                        style={{width:160, top:0}}
                                        value={condition.selectDistinct}
                                        onSelect={()=> setModalFunctionValueVisible(true)}
                                        onReset={()=> onChangeForm({blockIdx: blockIndex, idx: condition.idx, selectDistinct: null })}
                                        disabled={!selectorAvailable}
                                        />       
                                        <EnhancedModal
                                            visible={modalFunctionValueVisible}  
                                            onCancel={() => setModalFunctionValueVisible(false)}
                                            title={t('scenes.dataManager.fileMapping.wizard.addField.functions.iif.modal.title')}
                                            withDataLanguageSelector
                                            width={MODAL_WIDTH_MD}
                                            >
                                             <DataLanguageConsumer>
                                {dataLanguage => {
                                    //const language = dataLanguage || appLanguage;
                                     return !['IN','NOT IN'].includes(condition.operator) ?
                                        (
                                        <InfiniteScrollDataTable
                                            data={selectDistinctData && selectDistinctData.Data}
                                            rowTotal={selectDistinctData && selectDistinctData.Count}
                                            cols={selectDistinctData && selectDistinctData.Columns}
                                            onRowClick={(value) => {
                                                onChangeForm({blockIdx: blockIndex, idx: condition.idx, selectDistinct: value[Object.keys(value)[0]] })
                                                setModalFunctionValueVisible(false)
                                            }}
                                            onChange={({ filters, pageNum,pageSize,searchText,sortByDesc, sortCol}) => {
                                                onGetDistinctTempTable({
                                                    tempTable,
                                                    query: createExpressionToQuery(condition),
                                                    filters:getFilterObjFromViewerObj(
                                                        selectDistinctData && selectDistinctData.Columns,
                                                        searchText,
                                                        filters
                                                        ), 
                                                pageNum,
                                                pageSize,
                                                sortByDesc, 
                                                sortCol
                                                })
                                            }}
                                            />
                                        ) :
                                        (<InfiniteScrollDataTable
                                        data={selectDistinctData && selectDistinctData.Data}
                                        rowTotal={selectDistinctData && selectDistinctData.Count}
                                        cols={selectDistinctData && selectDistinctData.Columns}
                                        getRowKey={({VALUE}) => VALUE}
                                        rowSelection={{}}
                                        onChange={({ filters, pageNum,pageSize,searchText,sortByDesc, sortCol}) => {
                                            onGetDistinctTempTable({
                                                tempTable,
                                                query: createExpressionToQuery(condition),
                                                filters:getFilterObjFromViewerObj(
                                                    selectDistinctData && selectDistinctData.Columns,
                                                    searchText,
                                                    filters
                                                    ), 
                                            pageNum,
                                            pageSize,
                                            sortByDesc, 
                                            sortCol
                                            })
                                        }}
                                        tableActions={[
                                            {
                                                title:t('scenes.dataManager.fileMapping.wizard.addField.functions.iif.modal.addValues'),
                                                onClick:(values, deselect) => {
                                                   onChangeForm({blockIdx:blockIndex, idx: condition.idx, selectDistinct: values.map(e => e.VALUE)});
                                                   setModalFunctionValueVisible(false);
                                                   deselect();
                                                
                                                }
                                            }
                                            ]}
                                        />
                                        )
                                    }       
                                }  
                            </DataLanguageConsumer>    
                                        </EnhancedModal>       
                            </Col>
                        </Row>
                            {
                            (condition.functionName === 'LPad' || condition.functionName === 'RPad') &&
                            <Row type="flex" style={{alignItems:'center', gap:GUTTER_XS}}>
                                <span>{t('scenes.dataManager.fileMapping.wizard.addField.label.pattern')}</span>
                                <Input style={{width: 100}} 
                                value={!!condition.values.pattern ? condition.values.pattern : null}
                                onChange={({target})=> onChangeForm({blockIdx: blockIndex, idx:condition.idx, values:{ pattern:target.value}})
                                }
                                />
                            </Row>
                            }
                            {
                            condition.functionName  === 'Replace' && 
                            <Row type="flex" style={{ alignItems:'center', gap:GUTTER_MD}}>
                                <Col>
                                    <Row type="flex" style={{ alignItems:'center', gap:GUTTER_XS}}>
                                        <span>{t('scenes.dataManager.fileMapping.wizard.addField.label.replace')}</span>                       
                                        <Input style={{width: 100}}
                                         value={!!condition.values.replace ? condition.values.replace : null }
                                         onChange={({target})=> onChangeForm({blockIdx: blockIndex, idx:condition.idx, values:{replace:target.value}})
                                        }
                                        />   
                                    </Row>
                                </Col>
                                <Col>
                                    <Row type="flex" style={{  alignItems:'center', gap:GUTTER_XS}}>
                                        <span>{t('scenes.dataManager.fileMapping.wizard.addField.label.with')}</span>
                                        <Col >
                                            <Input style={{width: 100}}
                                             value={!!condition.values.with ? condition.values.with : null }
                                             onChange={({target})=> onChangeForm({blockIdx: blockIndex, idx:value.idx, values:{with:target.value}})
                                            }
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            }
                            {
                            condition.functionName === 'Substr' && 
                            <Row type="flex"  style={{ alignItems:'center', gap:GUTTER_MD}}>
                                <Col >
                                    <Row type="flex" style={{alignItems:'center',gap:GUTTER_XS}}>
                                        <span>{t('scenes.dataManager.fileMapping.wizard.addField.label.start')}</span>                            
                                        <Input style={{width: 100}}
                                            value={!!condition.values.start ? condition.values.start : null}
                                            onChange={({target})=> onChangeForm({blockIdx: blockIndex, idx:value.idx, values:{start:target.value}})
                                        }
                                        />
                                    </Row>
                                </Col>
                                <Col >
                                    <Row type="flex" style={{alignItems:'center',gap:GUTTER_XS }}>
                                        <span>{t('scenes.dataManager.fileMapping.wizard.addField.label.end')}</span>
                                        <Input style={{width: 100}}
                                            value={!!condition.values.end ? condition.values.end : null}
                                            onChange={({target})=> onChangeForm({blockIdx: blockIndex, idx:value.idx, values:{end:target.value}})}
                                        />
                                    </Row>
                                </Col>
                            </Row>
                            }
                            {        
                            (condition.functionName === 'Trim' || condition.functionName === 'LTrim' || condition.functionName === 'RTrim' ) &&
                            <Row type="flex" style={{ alignItems:'center', gap:GUTTER_XS}}>
                            <span>{t('scenes.dataManager.fileMapping.wizard.addField.label.charsToTrim')}</span>
                                <Input style={{width: 100}} 
                                value={!!condition.values.chars ? condition.values.chars : null}
                                onChange={({target}) => onChangeForm({blockIdx: blockIndex, idx:condition.idx, values:{chars:target.value}})}
                                />
                            </Row>
                            }
                    </Row>
                </Col>
            </Row>
        </Col>
    </Row>   
    </React.Fragment> }
  </React.Fragment>
  
);
}


export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(IffCondition);
